import { useEffect, useState } from "react";
import { api, imgSrc } from "../lib/api";
import { PageTitle } from "../components/site/PageTitle";
import { GalleryViewer } from "../components/site/GalleryViewer";

const SPANS = ["col-span-2 row-span-2", "row-span-2", "", "row-span-2", "col-span-2", ""];

export default function GalleryPage() {
  const [photos, setPhotos] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.gallery().then(setPhotos).catch(() => setPhotos([]));
  }, []);
  const list = photos || [];

  return (
    <>
      <PageTitle kicker="Moments" title="Gallery" />
      <section className="px-3 sm:px-5 lg:px-12 grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] sm:auto-rows-[200px] lg:auto-rows-[240px] grid-flow-dense gap-2 sm:gap-3" data-testid="gallery-grid">
        {photos && list.length === 0 && <p className="text-slate-400 col-span-full" data-testid="gallery-empty">No photos yet.</p>}
        {list.map((p, i) => (
          <button key={p.id} onClick={() => setOpen(i)} data-testid={`gallery-photo-${p.id}`}
            className={`img-zoom relative overflow-hidden rounded-lg card-surface ${SPANS[i % SPANS.length]}`}>
            <img src={imgSrc(p.image_url)} alt={p.caption || "00shot"} className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </section>
      {open !== null && list[open] && <GalleryViewer photos={list} index={open} setIndex={setOpen} />}
    </>
  );
}
